export let AdjustmentType = /*#__PURE__*/function (AdjustmentType) {
  AdjustmentType["client_price"] = "client_price";
  AdjustmentType["partner_price"] = "partner_price";
  AdjustmentType["qa"] = "qa";
  AdjustmentType["other"] = "other";
  return AdjustmentType;
}({});